import React from 'react'

const ManageEditPreferredCarrierDialogContext = React.createContext()

export default ManageEditPreferredCarrierDialogContext